"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BillboardNavigation", {
  enumerable: true,
  get: function get() {
    return _BillboardNavigation["default"];
  }
});
exports.CuriousPandaFinalForm = void 0;
Object.defineProperty(exports, "GetFieldDictionary", {
  enumerable: true,
  get: function get() {
    return _generateFieldDictionary["default"];
  }
});
exports.propTypes = exports.defaultProps = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = require("prop-types");
var _BillboardNavigation = _interopRequireDefault(require("./BillboardNavigation"));
var _FormOld = _interopRequireDefault(require("./FormOld"));
var _Form = _interopRequireDefault(require("./Form"));
var _generateFieldDictionary = _interopRequireDefault(require("./generateFieldDictionary"));
var _reactRedux = require("react-redux");
var _react = _interopRequireDefault(require("react"));
var _reducers = _interopRequireDefault(require("./reducers"));
var _styledReactModal = require("styled-react-modal");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CuriousPanda = function CuriousPanda(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: _reducers["default"]
  }, /*#__PURE__*/_react["default"].createElement(_styledReactModal.ModalProvider, null, /*#__PURE__*/_react["default"].createElement(_FormOld["default"], props)));
};
var CuriousPandaFinalForm = exports.CuriousPandaFinalForm = function CuriousPandaFinalForm(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: _reducers["default"]
  }, /*#__PURE__*/_react["default"].createElement(_styledReactModal.ModalProvider, null, /*#__PURE__*/_react["default"].createElement(_Form["default"], props)));
};

// exporting the defaultProps and propTypes
// so that we can use them in export.js
// which is the entry file for npm
var defaultProps = exports.defaultProps = {
  perPageValidation: false,
  forceUnregisterOnUnmount: true,
  destroyOnUnmount: true,
  form: "unnamed_form",
  scrollToTop: true,
  fieldSpacing: 0,
  children: false,
  id: undefined,
  disabled: false
};
var propTypes = exports.propTypes = {
  components: (0, _propTypes.shape)({
    display: _propTypes.object,
    field: _propTypes.object,
    fields: _propTypes.object,
    fieldArray: _propTypes.object,
    raw: _propTypes.object
  }),
  participant: (0, _propTypes.shape)({
    enrollment_identifier: _propTypes.string,
    participant_auth_token: _propTypes.string
  }),
  autoComplete: _propTypes.string,
  autoFocus: _propTypes.bool,
  perPageValidation: _propTypes.bool,
  page: _propTypes.number,
  form: _propTypes.string.isRequired,
  schema: _propTypes.array.isRequired,
  onSubmit: _propTypes.func.isRequired,
  validate: _propTypes.func,
  asyncValidate: _propTypes.func,
  enableReinitialize: _propTypes.bool,
  keepDirtyOnReinitialize: _propTypes.bool,
  updateUnregisteredFields: _propTypes.bool,
  forceUnregisterOnUnmount: _propTypes.bool,
  destroyOnUnmount: _propTypes.bool,
  scrollToTop: _propTypes.bool,
  editableInterface: _propTypes.object,
  editableFields: _propTypes.array,
  handlePageChange: _propTypes.func,
  onModifySchema: _propTypes.func,
  fieldSpacing: _propTypes.number,
  children: _propTypes.func.isRequired,
  id: _propTypes.string,
  disabled: _propTypes.bool
};
CuriousPanda.defaultProps = defaultProps;
CuriousPanda.propTypes = propTypes;
CuriousPandaFinalForm.defaultProps = defaultProps;
CuriousPandaFinalForm.propTypes = _objectSpread(_objectSpread({}, propTypes), {}, {
  form: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object])
});
var _default = exports["default"] = CuriousPanda;